import clsx from "clsx";

export const parentContainer = clsx(
    "h-iframeScreen md:h-solutionHero lg:pt-[60px] items-center justify-center flex",
    " bg-black flex-row w-full relative md:px-10 lg:px-0 lg:pb-0 overflow-hidden",
);
export const textContainer = clsx(
    "gap-2 flex h-full md:w-1/2 pt-10 px-8 flex-col items-center md:items-start",
    " text-center md:text-left justify-center text-white z-10",
);
export const title = clsx(
    "uppercase tracking-widest text-4xl font-bold md:text-6xl",
);
export const subheader = clsx(
    "md:my-10 my-4 max-w-[600px] text-lg md:text-2xl font-light",
);
export const link = clsx("w-[240px] md:w-[280px] lg:text-lg mt-4 md:mt-6");

export const animationContainer = clsx(
    "hidden md:flex h-auto w-auto min-w-[250px] lg:w-1/2 justify-center items-center mt-0 mb-0",
);
export const lottieContainer = clsx(
    "aspect-auto h-full w-[80%] items-center justify-center md:flex",
);
